import { render } from "./PartTransfers.vue?vue&type=template&id=0a4fb021"
import script from "./PartTransfers.vue?vue&type=script&lang=js"
export * from "./PartTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__